<template>
  <SwipeDialog
    :title="title"
    :context-menu-actions="contextMenuActions"
    :show-context-menu="showContextMenu"
    style="height: 100%; overflow: scroll"
    @closeFn="$router.go(-1)"
    @contextMenuFn="contextMenuFn"
  >
    <van-tabs
      v-model="tabIndex"
      color="#aa341b"
      style="position: sticky; top: 0px; z-index: 9"
    >
      <van-tab
        v-for="item in [name + '信息', '医学洞见']"
        :key="item"
        :title="item"
      />
    </van-tabs>
    <div style="padding: 10px">
      <div v-show="tabIndex === 0">
        <div v-for="(item, index) in fields" :key="index">
          <SchemaField
            v-if="item?.field"
            v-model="formState[item.field]"
            :schema="item"
            @change="item?.onChange && item.onChange($event, formState)"
          />
          <SchemaField v-else-if="item?.type === 'space'" :schema="item" />
        </div>
        <!-- 观念评分（选偏头痛治疗领域后显示） -->
        <div
          v-if="conceptDefinition.questions.length"
          class="concept-score-panel"
        >
          <div class="concept-score-header">
            <div class="concept-score-title">观念评分</div>
            <van-checkbox
              v-model="conceptTrackingEnabled"
              checked-color="#aa341b"
              class="concept-score-switch"
            >
              填写观念追踪
            </van-checkbox>
          </div>
          <template v-if="conceptTrackingEnabled">
            <div class="concept-score-hint">
              请完成以下三个观念的评分。
              <br />
              1 不认可；2 基本不认可；3 中立；4 基本认可；5 非常认可。
            </div>
            <div class="concept-score-content">
              <div
                v-for="(question, questionIndex) in conceptDefinition.questions"
                :key="question.insight_question_id"
                class="concept-score-row"
              >
                <strong class="concept-description">{{
                  question.description || `Concept ${questionIndex + 1}`
                }}</strong>
                <div class="concept-question-body">
                  <div class="concept-question">
                    <span>{{ question.question }}</span>
                  </div>
                  <div class="concept-score-options">
                    <div
                      v-for="score in [1, 2, 3, 4, 5]"
                      :key="score"
                      class="concept-score-option"
                      :class="{
                        'concept-score-option--active':
                          conceptScores[question.insight_question_id] === score,
                      }"
                      @click="setConceptScore(question.insight_question_id, score)"
                    >
                      {{ score }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- <SuggestInsightList @addClick="handleAddSuggestion($event)" /> -->
      </div>

      <div v-show="tabIndex === 1">
        <InsightEditList
          ref="insightEditList"
          :physician_id="physician?.physician_id"
          :source_msl_call_id="editId"
          :ta_name="callTaName"
        />
      </div>

      <BottomAction :confirm-loading="saveLoading" @save="save" />
    </div>
  </SwipeDialog>
</template>

<script>
import Vue from 'vue';
import {Dialog, Tab, Tabs, Picker, Popup, Icon, Button, Toast, Radio, RadioGroup, Checkbox} from 'vant';
import SwipeDialog from '@/views/layout/swipeDialog';
import SchemaField from '@/components/form/SchemaField.vue';
import BottomAction from './components/BottomAction.vue';
import {createVisitRecord} from '@/api/kol';
import {validateFields} from './util';
import {
  fetchOnePhysicianMslCalls,
  createMslCallCompanion,
  deleteMslCallCompanion,
  deleteMslCall,
  fetchInsightTopics,
  fetchPhysicianConcepts,
  createPhysicianConcept,
  updatePhysicianConcept,
  deletePhysicianConcept,
  CONCEPT_TRACKING_SCOPE,
  fetchOnePhysician,
} from '@/api/kol';
import RoundButton from './components/RoundButton.vue';
import InsightEditList from './components/InsightEditList.vue';
// import SuggestInsightList from './components/SuggestInsightList.vue';
import kvpKeysMixin from '@/mixins/kvpKey';
import {getLocalStorage} from '@/utils';
import {
  loadKvpCache,
  getCachedTas,
  getCachedProducts,
  findTaById,
  filterProductsByTaId,
} from '@/utils/kvpCache';
import {fetchVUsers} from '../../api/kol';

Vue.use(Popup);
Vue.use(Picker);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);

export default {
  components: {
    // SuggestInsightList,
    SwipeDialog,
    SchemaField,
    BottomAction,
    InsightEditList,
  },
  mixins: [
    kvpKeysMixin('call_channel'),
    kvpKeysMixin('msl_call_purpose')
  ],
  data() {
    return {
      saveLoading: false,
      tabIndex: 0,
      formState: {
        call_time: new Date(),
        physician_id: '',
        call_channel: '',
        call_purpose: '',
        call_ta: '',
        call_product: '',
        call_product_id: '',
        call_description: '',
        physician_msl_call__physician_msl_call_companions: [],
      },
      test: '',
      physicianOptions: [],
      physician: {},
      old_physician_msl_call__physician_msl_call_companions: [],
      contextMenuActions: [
        { text: '删除' },
      ],
      // 当前治疗领域下可选的产品或疾病
      filteredProducts: [],
      // 观念评分相关
      insightTopicList: [],
      conceptScores: {},
      existingConcepts: [],
      // 观念评分开关：打开才填写
      conceptTrackingEnabled: false,
    };
  },
  computed: {
    is_co_call() {
      return this.isCoVisit ? 1 : 0;
    },
    // 治疗领域：当前用户领域范围（从 UserTas 的 ta_id 过滤 ta 数据）
    therapyAreaOptions() {
      return getCachedTas().map((item) => ({
        text: item.kvp_key_name,
        id: item.kvp_key_id,
      }));
    },
    // 当前选中治疗领域的名称（formState.call_ta 存的是 id）
    callTaName() {
      return findTaById(this.formState.call_ta)?.kvp_key_name || '';
    },
    // 当前治疗领域下的观念评分 topic 与问题
    conceptDefinition() {
      const ta = findTaById(this.formState.call_ta);
      const taId = ta?.kvp_key_id;
      const topic = taId
        ? (this.insightTopicList || []).find(
          (item) =>
            item.scope === CONCEPT_TRACKING_SCOPE && item.ta_id === taId,
        ) || null
        : null;
      return {
        topic,
        questions: topic
          ? [...(topic.insight_topic__insight_questions || [])].sort(
            (left, right) =>
              Number(left.index || 0) - Number(right.index || 0),
          )
          : [],
      };
    },
    // 已填写的观念评分问题
    selectedConceptQuestions() {
      return this.conceptDefinition.questions.filter((question) =>
        [1, 2, 3, 4, 5].includes(
          Number(this.conceptScores[question.insight_question_id]),
        ),
      );
    },
    name() {
      return this.isCoVisit ? '协访' : '拜访';
    },
    title() {
      const action = this.editId ? '编辑' : '新建';
      return action + this.name;
    },
    isCoVisit() {
      return this.$route.query.isCoVisit === '1';
    },
    editId() {
      return this.$route.query?.id;
    },
    fields() {
      return this.isCoVisit ? this.coVisitFields : this.visitFields;
    },
    showContextMenu() {
      return this.$route.query?.id?.length > 0;
    },
    coVisitFields() {
      return [
        {
          field: 'physician_id',
          label: '协访客户',
          required: true,
          type: 'doctorSelectAll',
          options: this.physicianOptions,
        },
        {
          field: 'physician_msl_call__physician_msl_call_companions',
          label: '协访同事',
          type: 'userSelect',
          props: {
            fn: fetchVUsers,
          },
        },
        {
          field: 'call_time',
          type: 'date',
          label: '协访日期',
          required: true,
        },
        {
          type: 'space',
        },
        {
          field: 'call_channel',
          label: '协访形式',
          type: 'select',
          options: this.call_channel?.map((item) => item.kvp_key_name),
        },
        {
          field: 'call_ta',
          label: '治疗领域',
          type: 'select',
          options: this.therapyAreaOptions,
          onChange: (e) => this.handleTaChange(e),
          required: true,
        },
        {
          field: 'call_product',
          type: 'select',
          label: '产品或疾病',
          options: this.filteredProducts.map((item) => ({
            text: item.kvp_key_name,
            id: item.kvp_key_id,
          })),
          onChange: (e, form) => {
            const target = this.filteredProducts.find(
              (item) => item.kvp_key_id === e,
            );
            form.call_product_id = target?.kvp_key_id || '';
          },
        },
        {
          field: 'call_description',
          label: '协访说明',
          type: 'textarea',
          placeholder: '协访目的或协访结果说明',
        },
      ];
    },
    visitFields() {
      return [
        {
          field: 'physician_id',
          label: '拜访客户',
          required: true,
          type: 'doctorSelectAll',
          options: this.physicianOptions,
        },
        // {
        //   field: 'call_location',
        //   label: '拜访地点',
        //   required: true,
        //   type: 'select',
        //   options: ['院内'],
        // },
        {
          field: 'call_time',
          type: 'date',
          label: '拜访日期',
          required: true,
        },
        {
          field: 'call_channel',
          label: '拜访形式',
          type: 'select',
          options: this.call_channel.map((item) => item.kvp_key_name),
        },
        {
          type: 'space',
        },
        {
          field: 'call_purpose',
          label: '拜访目标',
          type: 'multiSelect',
          options: this.msl_call_purpose.map((item) => ({
            label: item.kvp_key_name,
            value: item.kvp_key_name,
          })),
          formatToValue(value) {
            return value?.join(',');
          },
          formatFromValue(value) {
            return value?.split(',');
          }
        },
        {
          field: 'physician_msl_call__physician_msl_call_companions',
          label: '医学部同行人',
          type: 'userSelect',
        },
        {
          field: 'call_ta',
          label: '治疗领域',
          type: 'select',
          options: this.therapyAreaOptions,
          onChange: (e) => this.handleTaChange(e),
          required: true,
        },
        {
          field: 'call_product',
          type: 'select',
          label: '产品或疾病',
          options: this.filteredProducts.map((item) => ({
            text: item.kvp_key_name,
            id: item.kvp_key_id,
          })),
          onChange: (e, form) => {
            const target = this.filteredProducts.find(
              (item) => item.kvp_key_id === e,
            );
            form.call_product_id = target?.kvp_key_id || '';
          },
        },
        {
          field: 'call_description',
          label: '拜访说明',
          type: 'textarea',
          placeholder: '拜访目的或拜访结果说明',
        },
      ];
    },
  },
  watch: {
    // 观念评分问题变化时，用 $set 预初始化 conceptScores 的所有 key，保证动态 key 响应式
    'conceptDefinition.questions'(questions) {
      questions.forEach((q) => {
        if (!(q.insight_question_id in this.conceptScores)) {
          this.$set(this.conceptScores, q.insight_question_id, null);
        }
      });
    },
  },
  async mounted() {
    // 治疗领域与产品或疾病数据已在登录时缓存，直接复用
    await loadKvpCache();

    if (this.editId) {
      await this.fetchOnePhysicianMslCalls();
    }

    // 加载观念评分 topic 列表（用于观念评分展示）
    this.insightTopicList = await fetchInsightTopics();

    const targetPhysicianId = this.$route.query?.physician_id;
    if (targetPhysicianId) {
      this.formState.physician_id = targetPhysicianId;
      // 从医生列表进入时，带医生信息（名称）过来
      await this.fetchTargetPhysicianInfo(targetPhysicianId);
    }

    // 根据已有治疗领域联动产品或疾病列表
    if (this.formState.call_ta) {
      this.filteredProducts = filterProductsByTaId(this.formState.call_ta);
    }

    // 编辑时加载已有的观念评分并回填
    if (this.editId) {
      await this.fetchExistingConcepts();
    }
  },
  methods: {
    // 治疗领域变更：联动产品或疾病，并清空已选产品
    handleTaChange(taId) {
      this.formState.call_ta = taId;
      this.filteredProducts = filterProductsByTaId(taId);
      this.formState.call_product = '';
      this.formState.call_product_id = '';
      // 换治疗领域后清空观念评分并关闭开关
      this.conceptScores = {};
      this.conceptTrackingEnabled = false;
    },
    // 设置观念评分（用 $set 保证动态 key 响应式）
    setConceptScore(questionId, score) {
      this.$set(this.conceptScores, questionId, score);
    },
    handleChange(field, value) {
      console.log(field, value, 'field value');
      this.formState[field] = value;
    },
    async fetchOnePhysicianMslCalls() {
      const {physician, ...res} = await fetchOnePhysicianMslCalls(this.editId);
      this.old_physician_msl_call__physician_msl_call_companions = [
        ...res.physician_msl_call__physician_msl_call_companions,
      ];
      this.physician = physician;
      // call_ta 用 id 存储，编辑回填时用 call_ta_id 作为选中值
      this.formState = {...res, call_ta: res.call_ta_id || ''};
    },
    // 从医生列表进入时，获取医生信息填充到 physicianOptions，用于展示医生名称
    async fetchTargetPhysicianInfo(physicianId) {
      if (!physicianId) return;
      try {
        const res = await fetchOnePhysician(physicianId);
        if (res?.physician_id) {
          this.physicianOptions = [
            {
              text: res.physician_name,
              id: res.physician_id,
            },
          ];
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 加载已有的观念评分（一次拜访一条记录，concept_scores 存 JSON 数组）
    async fetchExistingConcepts() {
      const sourceMslCallId = this.editId;
      if (!sourceMslCallId) return;

      const res = await fetchPhysicianConcepts(sourceMslCallId);
      this.existingConcepts = res?.value || [];
      if (!this.existingConcepts.length) return;

      let scores = [];
      try {
        scores = JSON.parse(this.existingConcepts[0].concept_scores || '[]');
      } catch (e) {
        scores = [];
      }
      const scoreMap = {};
      scores.forEach((item) => {
        if (item.question_id !== undefined && item.score !== undefined) {
          scoreMap[item.question_id] = Number(item.score);
        }
      });
      this.conceptScores = scoreMap;
      // 有评分记录说明之前打开过开关
      if (Object.keys(scoreMap).length > 0) {
        this.conceptTrackingEnabled = true;
      }
    },
    // 观念评分时间：取拜访日期（call_time），未选择时回退为当前时间
    getConceptRecordTime() {
      const callTime = this.formState.call_time;
      if (!callTime) return new Date().toISOString();
      const date = new Date(callTime);
      if (Number.isNaN(date.getTime())) return new Date().toISOString();
      return date.toISOString();
    },
    // 构造观念评分数组
    buildConceptScoresPayload() {
      return this.selectedConceptQuestions.map((question, index) => ({
        question_id: question.insight_question_id,
        question: question.question,
        concept_name: question.description || question.question,
        order: Number(question.index || index + 1),
        score: Number(this.conceptScores[question.insight_question_id]),
      }));
    },
    // 观念评分增量保存：开关打开才保存，关闭则删除已有记录
    async saveConceptScores(sourceMslCallId) {
      const existingConcept = this.existingConcepts[0];

      // 开关关闭：删除已有记录（如有）
      if (!this.conceptTrackingEnabled) {
        if (existingConcept?.physician_concept_id) {
          await deletePhysicianConcept(existingConcept.physician_concept_id);
          this.existingConcepts = [];
        }
        return;
      }

      const topic = this.conceptDefinition.topic;
      const selectedQuestions = this.selectedConceptQuestions;

      if (selectedQuestions.length > 0) {
        const conceptObj = {
          physician_concept_id: existingConcept?.physician_concept_id,
          insight_topic_id: topic?.insight_topic_id,
          physician_id: this.formState.physician_id,
          ta_id: topic?.ta_id || '',
          ta: topic?.ta || '',
          concept_scores: JSON.stringify(this.buildConceptScoresPayload()),
          physician_msl_call_id: sourceMslCallId,
          record_user_id: getLocalStorage('user_id'),
          record_user_name: getLocalStorage('user_name'),
          // 评分时间取拜访日期，而不是保存时刻
          record_time: this.getConceptRecordTime(),
        };

        if (existingConcept?.physician_concept_id) {
          await updatePhysicianConcept(conceptObj);
        } else {
          const createRes = await createPhysicianConcept(conceptObj);
          if (createRes?.entity?.physician_concept_id) {
            this.existingConcepts = [
              {
                ...conceptObj,
                physician_concept_id: createRes.entity.physician_concept_id,
              },
            ];
          }
        }
      } else if (existingConcept?.physician_concept_id) {
        await deletePhysicianConcept(existingConcept.physician_concept_id);
        this.existingConcepts = [];
      }
    },

    async save() {
      const {
        physician_msl_call__physician_msl_call_companions,
        physician,
        ...formState
      } = this.formState;

      if (!validateFields(this.fields, formState)) return;
      this.saveLoading = true;
      try {
        const ta = findTaById(formState.call_ta);
        const product = getCachedProducts().find(
          (item) => item.kvp_key_id === formState.call_product,
        );
        const res = await createVisitRecord({
          ...formState,
          call_ta: ta?.kvp_key_name || '',
          call_ta_id: formState.call_ta || '',
          call_product: product?.kvp_key_name || '',
          call_product_id: formState.call_product || '',
          is_co_call: this.is_co_call,
          call_msl_user_id: getLocalStorage('user_id'),
          call_msl_user_name: getLocalStorage('user_name'),
        });
        const source_msl_call_id = res?.entity?.physician_msl_call_id;

        // 保存观念评分（一次拜访一条记录）
        await this.saveConceptScores(source_msl_call_id);

        // 创建/编辑对应的医学洞见
        await this.$refs.insightEditList?.save?.(
          source_msl_call_id,
          this.isCoVisit ? '协访' : '拜访',
          this.formState.physician_id,
          this.formState.call_time
        );

        // 同行人增量保存：只删除被移除的，只新增新加入的
        const oldCompanions =
          this.old_physician_msl_call__physician_msl_call_companions || [];
        const newCompanions =
          physician_msl_call__physician_msl_call_companions || [];
        const newUserIds = newCompanions.map((item) => item.user_id);

        await Promise.all(
          oldCompanions
            .filter((oldItem) => !newUserIds.includes(oldItem.user_id))
            .map((item) =>
              deleteMslCallCompanion(item.physician_msl_call_companion_id),
            ),
        );

        const oldUserIds = oldCompanions.map((item) => item.user_id);
        await Promise.all(
          newCompanions
            .filter((newItem) => !oldUserIds.includes(newItem.user_id))
            .map((item) =>
              createMslCallCompanion({
                physician_msl_call_id: source_msl_call_id,
                companion_type: '医学部同行人',
                user_id: item.user_id,
                user_name: item.user_name,
              }),
            ),
        );
        Toast(this.editId ? '修改成功' : '创建成功');
        this.$router.go(-1);
      } finally {
        this.saveLoading = false;
      }
    },
    handleAddSuggestion(item) {
      this.tabIndex = 1;
      this.$refs.insightEditList.addInsightForm({
        insight_question: item,
      });
    },
    contextMenuFn(action) {
      if (action === '删除') {
        Dialog.confirm({
          message: "是否删除这条记录",
          beforeClose: this.beforeClose,
        });
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        this.saveLoading = true;
        if (this.editId) {
          deleteMslCall(this.editId).then((res) => {
            if (res?.value === this.editId) {
              this.$toast.success("删除成功");
              setTimeout(() => {
                this.$router.go(-1);
              }, 100);
            } else {
              this.$toast.fail("删除失败，请重试");
            }
            this.saveLoading = false;
            done();
          }).catch((err) => {
            console.log(err);
            this.$toast.fail("删除失败，请重试");
            this.saveLoading = false;
            done();
          });
        } else {
          this.$toast.fail("删除失败，请重试");
          this.saveLoading = false;
          done();
        }
      } else if (action === 'cancel') {
        done();
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-tab--active {
  color: #aa341b;
}

.concept-score-panel {
  margin: 12px 16px;
  padding: 10px;
  border: 1px solid #f1d8d0;
  border-radius: 8px;
  background: #fff9f7;
}

.concept-score-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.concept-score-title {
  color: #aa341b;
  font-size: 15px;
  font-weight: 600;
}

.concept-score-switch {
  font-size: 13px;
  color: #333;
}

.concept-score-hint {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f3e4df;
  color: #777;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-line;
}

.concept-score-row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}

.concept-score-row + .concept-score-row {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f3e4df;
}

.concept-description {
  color: #aa341b;
  font-size: 13px;
}

.concept-question-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.concept-question {
  display: flex;
  flex: 1;
  font-size: 12px;
  line-height: 1.5;
  color: #374151;
}

.concept-score-options {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
}

.concept-score-option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e3e3e3;
  border-radius: 50%;
  color: #666;
  font-size: 15px;
  font-weight: 500;
  background: #fff;
  transition: all 0.2s;
  cursor: pointer;
}

.concept-score-option--active {
  border-color: #aa341b;
  background: #aa341b;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(170, 52, 27, 0.3);
}
</style>
